<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <v-row class="ps-12 pb-0 mb-0">
      <v-col>
        <p class="font-weight-medium grey--text text-h5">
          Procedures
        </p>
      </v-col>
    </v-row>
    <v-row class="ps-12 pe-12 mt-0">
      <v-col
        md="4"
        sm="12"
        cols="12"
      >
        <VTextField
          ref="procedure-code"
          v-model="data.code"
          :label="$t('forms.labels.code')"
          :rules="{ required: true, max: 50 }"
          outlined
          @input="updateData"
        />
      </v-col>
      <v-col
        md="4"
        sm="12"
        cols="12"
      >
        <VSelect
          ref="procedure-type"
          v-model="data.type"
          itemValue="key"
          required
          :label="$t('forms.labels.type')"
          :items="types"
          :validateAtInitialization="isEdition"
          outlined
          data-cy="procedureType"
          @input="updateData"
        />
      </v-col>
      <v-col
        md="4"
        sm="12"
        cols="12"
      >
        <VSelect
          ref="procedure-subtype"
          v-model="data.subType"
          clearable
          itemValue="key"
          :disabled="isSubTypeDisabled"
          :label="$t('forms.labels.subType')"
          :items="subTypes"
          :validateAtInitialization="isEdition"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="ps-12 pe-12">
      <v-col>
        <VTextField
          ref="procedure-name"
          v-model="data.name[selectedLang]"
          :label="$t('forms.labels.name')"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="ps-12 pe-12">
      <v-col>
        <VFile
          v-model="data.files[selectedLang]"
          :isEdition="isEdition"
          :label="$t(`forms.labels.file`)"
          :rules="validationFileRules"
          :showSize="!isEdition"
          isInProcedure
          outlined
          appendOuterIcon="mdi-eye"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import FormFilesMixin from '@/mixins/FormFilesMixin';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect';
import VFile from '@/components/shared/widgets/forms/VuetifyInputs/VFile';
import { mapGetters } from 'vuex';

export default {
    components: {
        ValidationObserver,
        VTextField,
        VSelect,
        VFile,
        SlotScopeWatcher,
    },
    mixins: [
        FormFilesMixin,
    ],
    props: {
        procedure: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        typeEnum: {
            type: Array,
            required: true,
        },
        subTypeEnum: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            data: { name: {}, files: {} },
            validationFileRules: {
                mimes: ['application/pdf'],
                size: 50 * 1024,
            },
        };
    },
    computed: {
        ...mapGetters([
            'selectedLang',
        ]),
        types() {
            return this.typeEnum.map(type => ({
                name: this.$t(`forms.labels.${type}`),
                key: type,
            }));
        },
        subTypes() {
            return this.subTypeEnum.map(type => ({
                name: this.$t(`procedures.${type}`),
                key: type,
            }));
        },
        isSubTypeDisabled() {
            return this.data.type !== 'mechanic';
        },
        type() {
            return this.data.type;
        },
    },
    watch: {
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
        type() {
            if (this.isAnalyticSelected) {
                this.data.subType = undefined;
            }
        },
    },
    created() {
        if (this.isEdition) {
            this.prepareData();
        }
    },
    methods: {
        async prepareData() {
            const data = await this.prepareEditData(this.procedure);
            this.data = data;
        },
    },
};
</script>
